export const enum SaleStatusType {
  /** 未登録 */
  _0_MI_TOUROKU,
  /** 販売中 */
  _1_HANBAI_CHU,
  /** 販売停止 */
  _2_TEISHI,
}
